/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { fixedT, translationKeys } from "./i18nBasis";
import { languages } from "./languages";

export default interface Country {
    iso: string,
    caption: string,
    languageCode: string;
}

export function getCountries(): Country[] {
    const countries: Country[] = [
        getCountryGermany(),
        { iso: "AT", caption: fixedT(translationKeys.country.austria), languageCode: languages.de },
        { iso: "BE", caption: fixedT(translationKeys.country.belgium), languageCode: languages.de },
        { iso: "ES", caption: fixedT(translationKeys.country.spain), languageCode: "es" },
        { iso: "IT", caption: fixedT(translationKeys.country.italy), languageCode: "it" },
        { iso: "NL", caption: fixedT(translationKeys.country.netherlands), languageCode: "nl" },
    ];

    return countries.sort((a, b) => a.caption.localeCompare(b.caption));
}

export function getCountryGermany(): Country {
    return { iso: "DE", caption: fixedT(translationKeys.country.germany), languageCode: languages.de };
}
